var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.22 21.6299C13.04 21.6299 11.37 20.7999 10.05 16.8299L9.33 14.6699L7.17 13.9499C3.21 12.6299 2.38 10.9599 2.38 9.77995C2.38 8.60995 3.21 6.92995 7.17 5.59995L15.66 2.76995C17.78 2.05995 19.55 2.26995 20.64 3.34995C21.73 4.42995 21.94 6.20995 21.23 8.32995L18.4 16.8199C17.07 20.7999 15.4 21.6299 14.22 21.6299ZM7.64 7.02995C4.86 7.95995 3.87 9.05995 3.87 9.77995C3.87 10.4999 4.86 11.5999 7.64 12.5199L10.16 13.3599C10.38 13.4299 10.56 13.6099 10.63 13.8299L11.47 16.3499C12.39 19.1299 13.5 20.1199 14.22 20.1199C14.94 20.1199 16.04 19.1299 16.97 16.3499L19.8 7.85995C20.31 6.31995 20.22 5.05995 19.57 4.40995C18.92 3.75995 17.66 3.67995 16.13 4.18995L7.64 7.02995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.11 14.4C9.92 14.4 9.73 14.33 9.58 14.18C9.29 13.89 9.29 13.41 9.58 13.12L13.16 9.53C13.45 9.24 13.93 9.24 14.22 9.53C14.51 9.82 14.51 10.3 14.22 10.59L10.64 14.18C10.5 14.33 10.3 14.4 10.11 14.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7d51618eb022146c11e77d868ed29189.svg";
export { ForwardRef as ReactComponent };